import { Box, Button, Grid, InputAdornment, TextField } from '@mui/material';
import { Add, SearchOutlined } from '@mui/icons-material';
import { DestinationFilter } from '../../model/destination.model';

interface DestinationHeaderController {
  filter: DestinationFilter | null;
  onFilterChange: (filter?: DestinationFilter | null) => void;
}

interface IProps {
  ctrl: DestinationHeaderController;
  label: string;
  handleOpenDialog: () => void;
}

const Header = ({ handleOpenDialog, ctrl, label }: IProps) => {
  return (
    <Box sx={{ py: 3, px: 3 }}>
      <Grid container spacing={1}>
        <Grid item xs={12} md={3}>
          <TextField
            value={ctrl.filter?.search ?? ''}
            onChange={(e) => {
              const val = e.target.value.trim();
              if (val.length > 0) {
                ctrl.onFilterChange({ ...ctrl.filter, search: val });
              } else {
                const f = { ...ctrl.filter };
                delete f.search;
                ctrl.onFilterChange(f);
              }
            }}
            size="small"
            placeholder={`ປ້ອນຊື່${label}`}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchOutlined />
                </InputAdornment>
              ),
              style: { borderRadius: '30px' },
            }}
            fullWidth
          />
        </Grid>
        <Box flex={1} />
        <Grid
          item
          xs={12}
          md={3}
          sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'end' }}
        >
          <Button
            variant="contained"
            sx={{ width: { md: '84%', xs: '100%' }, borderRadius: 5 }}
            onClick={handleOpenDialog}
            fullWidth
          >
            <Add /> ເພີ່ມ{label}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Header;
